import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { AvatarPessoaComponent } from '../../../shared/components/redesign/avatar-pessoa/avatar-pessoa.component';
import { MethodsUtils } from '../../../shared/util/methods.utils';
import { animacaoPop } from '../../utils/chat-animacoes.utils';
import { VisualizadorFigurinhaData } from './models/visualizador-figurinha-data.model';
import { VisualizadorFigurinhaResultado } from './models/visualizador-figurinha-resultado.model';

@Component({
  selector: 'app-visualizador-figurinha',
  standalone: true,
  imports: [DatePipe, MatIcon, MatTooltip, AvatarPessoaComponent],
  animations: [animacaoPop],
  templateUrl: './visualizador-figurinha.component.html',
  styleUrl: './visualizador-figurinha.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisualizadorFigurinhaComponent {
  readonly data = inject<VisualizadorFigurinhaData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<VisualizadorFigurinhaComponent, VisualizadorFigurinhaResultado>>(MatDialogRef);

  readonly comErro = signal(false);
  readonly fotoComErro = signal(false);
  readonly rotuloData = this.data.data ? MethodsUtils.rotuloDia(new Date(this.data.data)) : '';

  responder(): void {
    this.dialogRef.close({ responder: true });
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
